import { useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { Button } from 'components/UI/Button/Button';

import './EventFinderForm.scss';

export const EventFinderForm = (props) => {
  const { eventFinderFormData, genreDefaultValue, timeDefaultValue } = props;
  const [chosenGenre, setChosenGenre] = useState(null);
  const [chosenTime, setChosenTime] = useState(null);

  const genreUpdateHandler = (dropdownValue) => {
    setChosenGenre(dropdownValue);
  };
  const timeUpdateHandler = (dropdownValue) => {
    setChosenTime(dropdownValue);
  };

  const getFormattedDate = () => {
    const todaysDate = new Date();
    const year = todaysDate.getFullYear();
    const month = todaysDate.getMonth() + 1;
    const day = todaysDate.getDate();
    return `${[year, month, day].join('-')}`;
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();

    let timeUrlFragment;

    const isSpecificTimeChosen = chosenTime === 'time' || chosenTime === 'next30';
    const genreUrlFragment = !chosenGenre ? 'whats-on' : `whats-on/${chosenGenre}`;

    if (!chosenGenre && !chosenTime) {
      timeUrlFragment = '/event-calendar';
    } else if (!chosenGenre && isSpecificTimeChosen) {
      timeUrlFragment = `/event-calendar?startDate=${getFormattedDate()}`;
    } else if (chosenGenre && chosenTime) {
      timeUrlFragment = `?startDate=${getFormattedDate()}`;
    } else {
      timeUrlFragment = '';
    }

    const redirectUrl = `/${genreUrlFragment}${timeUrlFragment}`;
    window.location.href = redirectUrl;
  };

  return (
    <form
      onSubmit={formSubmitHandler}
      className="event-finder__form row"
      data-testid="event-finder-form"
    >
      <div
        className="event-finder__dropdown col-xs-6 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-2"
        data-testid="genre-dropdown"
      >
        <DropdownWithMenu
          defaultValue="All events"
          defaultChosenValue={genreDefaultValue}
          menuData={eventFinderFormData.genres}
          dropdownChangeHandler={genreUpdateHandler}
          extendMenuClass="genre-dropdown"
        />
      </div>
      <div
        className="event-finder__dropdown col-xs-6 col-md-3 col-lg-3"
        data-testid="time-dropdown"
      >
        <DropdownWithMenu
          defaultValue="At any time"
          defaultChosenValue={timeDefaultValue}
          menuData={eventFinderFormData.times}
          dropdownChangeHandler={timeUpdateHandler}
          singleColumn
          extendMenuClass="time-dropdown"
        />
      </div>
      <div className="col-xs-12 col-sm-12 col-md-4 col-lg-2">
        <Button type="submit" extendClass="event-finder__submit-button">
          Find events
        </Button>
      </div>
    </form>
  );
};

EventFinderForm.propTypes = {
  eventFinderFormData: PropTypes.object.isRequired,
  genreDefaultValue: PropTypes.string.isRequired,
  timeDefaultValue: PropTypes.string.isRequired,
};
